export { default } from './DynamicListWrapper.vue'
